var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperational(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 16.0003H26.026C25.4433 15.9991 24.8762 16.1887 24.4115 16.5403C23.9468 16.8918 23.61 17.3859 23.4527 17.947L20.3193 29.0937C20.2992 29.1629 20.257 29.2237 20.1993 29.267C20.1416 29.3103 20.0715 29.3337 19.9993 29.3337C19.9272 29.3337 19.857 29.3103 19.7993 29.267C19.7416 29.2237 19.6995 29.1629 19.6793 29.0937L12.3193 2.90699C12.2992 2.83775 12.257 2.77693 12.1993 2.73366C12.1416 2.69038 12.0715 2.66699 11.9993 2.66699C11.9272 2.66699 11.857 2.69038 11.7993 2.73366C11.7417 2.77693 11.6995 2.83775 11.6793 2.90699L8.54602 14.0537C8.3893 14.6125 8.05452 15.105 7.5925 15.4563C7.13048 15.8077 6.56644 15.9987 5.98602 16.0003H2.66602",
    stroke: "#142454",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperational);
export default __webpack_public_path__ + "static/media/Operational.cd0ff5846769bf5acbdcf7aceaa3750f.svg";
export { ForwardRef as ReactComponent };